const name = "Subcontainers 1";
const bytecode =
  "0xef0001010008020002000d0006030002003200140400000000800004008000026000600060006000ec00e5000160006000ee01ef000101000402000100060300010014040000000080000260006000ee00ef00010100040200010001040000000080000000ef00010100040200010001040000000080000000";

const subcontainers = { name, bytecode };

export default subcontainers;
